import { render } from "./describe.vue?vue&type=template&id=49121b1a"
import script from "./describe.vue?vue&type=script&lang=js"
export * from "./describe.vue?vue&type=script&lang=js"

import "./describe.vue?vue&type=style&index=0&id=49121b1a&lang=scss&scope=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/describe.vue'],['render',render],['__file',"describe.vue"]])

export default __exports__